import { Link } from "react-router-dom";

const entries = [
  { icon: "ri-film-line", label: "电影", desc: "高清佳片", to: "/movies", tone: "primary" },
  { icon: "ri-tv-2-line", label: "电视剧", desc: "热播剧集", to: "/tvshows", tone: "accent" },
  { icon: "ri-newspaper-line", label: "影视资讯", desc: "行业动态", to: "/news", tone: "secondary" },
  { icon: "ri-search-eye-line", label: "找片搜索", desc: "精准检索", to: "/search", tone: "primary" },
];

const toneClass: Record<string, string> = {
  primary: "bg-primary-50 text-primary-600",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function QuickEntry() {
  return (
    <section className="container-page -mt-8 relative z-20 md:-mt-10">
      <div className="grid grid-cols-2 gap-3 rounded-lg border border-background-200 bg-background-50 p-3 md:grid-cols-4 md:gap-4 md:p-4">
        {entries.map((entry) => (
          <Link
            key={entry.label}
            to={entry.to}
            className="group flex items-center gap-3 rounded-lg p-3 transition-colors hover:bg-background-100 md:p-4"
          >
            <span
              className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg transition-transform group-hover:scale-105 md:h-12 md:w-12 ${toneClass[entry.tone]}`}
            >
              <i className={`${entry.icon} text-xl md:text-2xl`} />
            </span>
            <span className="min-w-0">
              <span className="block truncate text-sm font-medium text-foreground-950 md:text-base">
                {entry.label}
              </span>
              <span className="block truncate text-xs text-foreground-400">{entry.desc}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}